import React from "react";
import $ from "jquery";
import {
  CurrencyRenderer,
  CurrencyRendererRed,
  NumberRenderer,
  GetParams,
  MWBaseURL,
  PercentRenderer,
  GetStandardDTButtons,
  CurrencyRendererPrice,
  DecimalRenderer,
} from "./../Utilities.js";
import { createApiClient } from "../api/ApiClient";

class TagGroupTbl extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: null,
      dateEnd: null,
      start: null,
      end: null,
      firm: null,
      acct: null,
      sybl: null,

      needToUpdate: false,

      selectedRows: null,
    };

    this.table = null;
  }

  static getDerivedStateFromProps(props, state) {
    if (
      state.date !== props.date ||
      state.dateEnd !== props.dateEnd ||
      state.firm !== props.firm ||
      state.acct !== props.acct ||
      state.sybl !== props.sybl ||
      (props.tag && state.tag !== props.tag) ||
      props.tagAndMode !== state.tagAndMode
    ) {
      return { ...props, needToUpdate: true };
    }
    return { ...props };
  }

  componentDidUpdate(props, state) {
    if (this.state.needToUpdate) {
      let self = this;
      this.setState({ needToUpdate: false }, function () {
        if (self.table !== null) {
          self.table.ajax
            .url(MWBaseURL() + "tag_groups?" + GetParams(self.state))
            .load();
        }
      });
    }
  }

  async componentDidMount() {
    let self = this;
    const apiClient = createApiClient();
    this.table = $("#tagGroupTbl").DataTable({
      select: {
        style: "single",
        selector: "td:not(:first-child)",
      },
      dom: "Bfrtip",
      buttons: [...GetStandardDTButtons("Trac P&L Explorer Analytics", true)],
      scrollY: "600px",
      scrollX: true,
      responsive: true,
      stateSave: true,
      stateDuration: 0, //infinite
      paging: false,
      info: false,
      filter: true,
      ajax: await apiClient.getDataTableAjaxSettings(
        MWBaseURL() + "tag_groups?" + GetParams(self.state),
      ),
      columns: [
        {
          title: "Tag",
          data: "tag",
          className: "clickable filterable",
          render: function (data, type, row, meta) {
            let values = '<div title="' + data + '">';
            let tags = data.split(",");
            for (let i in tags) {
              if (i >= 2) {
                values += "+" + (tags.length - i);
                break;
              } else {
                values +=
                  "<div style='background: #dadada; display: inline; border-radius: 3px; margin:2px'>" +
                  tags[i] +
                  "</div>";
              }
            }
            values += "</div>";
            return values;
          },
        },
        {
          title: "Total",
          data: "total",
          render: NumberRenderer,
          className: "text-right",
        },
        {
          title: "Pos Trades",
          data: "pos_trades",
          render: NumberRenderer,
          className: "text-right",
        },
        {
          title: "Neg Trades",
          data: "neg_trades",
          render: NumberRenderer,
          className: "text-right",
        },
        {
          title: "Avg Win",
          data: "avg_win",
          render: CurrencyRenderer,
          className: "text-right",
        },
        {
          title: "Avg Loss",
          data: "avg_loss",
          render: CurrencyRenderer,
          className: "text-right",
        },
        {
          title: "Net P&L",
          data: "pnl",
          render: CurrencyRendererRed,
          className: "text-right",
        },
        {
          title: "Expected Value",
          data: "ev",
          render: CurrencyRenderer,
          className: "text-right",
        },
        {
          title: "Win Ratio",
          data: "win_ratio",
          render: (data) => PercentRenderer(data, 2),
          className: "text-right",
        },
        {
          title: "Median P&L",
          data: "percentile_50",
          render: CurrencyRendererRed,
          className: "text-right",
        },
        /*{title: "WtdWin", data: "wtd_win", render: CurrencyRendererRed, className: "text-right"},*/
        {
          title: "AvgShares",
          data: "avg_shares",
          render: (data) => DecimalRenderer(data, 2),
          className: "text-right",
        },
        {
          title: "EV/Sh",
          data: "ev_sh",
          render: CurrencyRendererPrice,
          className: "text-right",
        },
        {
          title: "ADPS",
          data: "adps",
          render: CurrencyRendererPrice,
          className: "text-right",
        },
      ],
    });
    this.table.on("select deselect", function (e, dt, type, indexes) {
      let rows = self.table.rows({ selected: true }).data().toArray();
      self.state.refilter({
        selectedRows: rows,
        updateCount: self.state.updateCount + 1,
      });
    });
    this.setState({ needToUpdate: false });

    $("#tagGroupTbl tbody").on("click", "tr .filterable", function () {
      let row = self.table.row(this).data();
      let obj = {
        view: 4,
        selectedRows: [],
        selectedx0: null,
        selectedx1: null,
      };
      if (!self.state.tagAndMode) {
        obj.selectedTag = [row.tag];
      } else if (!self.state.tag.length) {
        obj.tagAndMode = false;
        obj.selectedTag = [row.tag];
      }
      self.state.refilter(obj);
    });
  }

  render() {
    return (
      <div>
        <table
          id="tagGroupTbl"
          className="display compact selectable"
          width="100%"
        ></table>
      </div>
    );
  }
}

export default TagGroupTbl;
